module.exports = __webpack_public_path__ + "components/bookings-nav/static/chevron-left-e4f1a9fd5999829af5dab770c52f245f.svg";